import { render, staticRenderFns } from "./DoctorNew.vue?vue&type=template&id=18b18af0"
import script from "./DoctorNew.vue?vue&type=script&lang=js"
export * from "./DoctorNew.vue?vue&type=script&lang=js"
import style0 from "./DoctorNew.vue?vue&type=style&index=0&id=18b18af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports